import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Navbar from "./pages/Navbar";
import Intrested from "./pages/Intrested";
import Home from "./pages/Home";
import Book from "./pages/Book";
import Allpages from "./pages/Allpages";
import Profile from "./pages/Profile";
import Internship from "./pages/Internship";
import Mentorship from "./pages/Mentorship";
import Partnership from "./pages/Partnership";
import BookDetail from "./pages/BookDetail"; 
import CartPage from "./pages/CartPage";
import WishlistPage from "./pages/WishlistPage";
import Footer from "./pages/Footer";
import PrivacyPolicy from "./pages/privacy_policy";
import RefundPolicy from "./pages/RefundPolicy";
import CancellationPolicy from "./pages/CancellationPolicy";
import Checkout from "./pages/Checkout";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentFailed from "./pages/PaymentFailed";
import AWSCredentialsTester from './pages/AwsCredentialsTester';
import CoursePage from "./pages/CoursePage";
import CourseCard from './pages/CourseCard';
import Video from "./pages/video";
import Presentations from "./pages/Presentations";
import Signup from "./pages/Signup";
import Login from "./pages/Login";
import AdminConfig from './pages/AdminConfig';
import FeaturedBooks from "./pages/Featuredbooks";

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("userToken");
  const isAuthenticated = !!token;
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

// Public Route Component (redirect to featured-books if already logged in)
const PublicRoute = ({ children }) => {
  const token = localStorage.getItem("userToken");
  const isAuthenticated = !!token;
  
  if (isAuthenticated) {
    return <Navigate to="/featured-books" replace />;
  }
  
  return children;
};

// Layout component with conditional Navbar
const Layout = ({ children }) => {
  const location = useLocation();
  
  // Hide Navbar on login and signup pages
  const hideNavbar = location.pathname === '/login' || location.pathname === '/signup';
  
  return (
    <>
      {!hideNavbar && <Navbar />}
      {children}
      {!hideNavbar && <Footer />}
    </>
  );
};

function App() {
  return (
    <Router>
      <div className="app-container" style={{ position: "relative" }}>
        <Layout>
          <Routes>
            {/* ========== PUBLIC ROUTES ========== */}
            
            {/* Signup Page */}
            <Route 
              path="/signup" 
              element={
                <PublicRoute>
                  <Signup />
                </PublicRoute>
              } 
            />
            
            {/* Login Page */}
            <Route 
              path="/login" 
              element={
                <PublicRoute>
                  <Login />
                </PublicRoute>
              } 
            />
            
            {/* ========== PROTECTED ROUTES ========== */}
            
            {/* Root Route - Redirect to featured-books */}
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Navigate to="/featured-books" replace />
                </ProtectedRoute>
              }
            />
            
            {/* Featured Books Page - First page after login */}
            <Route 
              path="/featured-books" 
              element={
                <ProtectedRoute>
                  <FeaturedBooks />
                </ProtectedRoute>
              } 
            />
            
            {/* Main Dashboard - Shows all content (accessed via View All button) */}
            <Route 
              path="/allpages" 
              element={
                <ProtectedRoute>
                  <Allpages />
                </ProtectedRoute>
              } 
            />
            
            {/* Interest Selection - Via Settings */}
            <Route 
              path="/interests" 
              element={
                <ProtectedRoute>
                  <Intrested />
                </ProtectedRoute>
              } 
            />
            
            {/* Profile */}
            <Route 
              path="/profile" 
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              } 
            />
            
            {/* Internship */}
            <Route 
              path="/internship" 
              element={
                <ProtectedRoute>
                  <Internship />
                </ProtectedRoute>
              } 
            />
            
            {/* Mentorship */}
            <Route 
              path="/mentorship" 
              element={
                <ProtectedRoute>
                  <Mentorship />
                </ProtectedRoute>
              } 
            />
            
            {/* Partnership */}
            <Route 
              path="/partnership" 
              element={
                <ProtectedRoute>
                  <Partnership />
                </ProtectedRoute>
              } 
            />
            
            {/* Book */}
            <Route 
              path="/book" 
              element={
                <ProtectedRoute>
                  <Book />
                </ProtectedRoute>
              } 
            />
            
            {/* Book Detail */}
            <Route 
              path="/book-detail" 
              element={
                <ProtectedRoute>
                  <BookDetail />
                </ProtectedRoute>
              } 
            />
            
            {/* Cart */}
            <Route 
              path="/cart" 
              element={
                <ProtectedRoute>
                  <CartPage />
                </ProtectedRoute>
              } 
            />
            
            {/* Wishlist */}
            <Route 
              path="/wishlist" 
              element={
                <ProtectedRoute>
                  <WishlistPage />
                </ProtectedRoute>
              } 
            />
            
            {/* Checkout */}
            <Route 
              path="/checkout" 
              element={
                <ProtectedRoute>
                  <Checkout />
                </ProtectedRoute>
              } 
            />
            
            {/* Course Page */}
            <Route 
              path="/CoursePage" 
              element={
                <ProtectedRoute>
                  <CoursePage />
                </ProtectedRoute>
              } 
            />
            
            {/* Course Card */}
            <Route 
              path="/CourseCard" 
              element={
                <ProtectedRoute>
                  <CourseCard />
                </ProtectedRoute>
              } 
            />
            
            {/* Video Library */}
            <Route 
              path="/videos" 
              element={
                <ProtectedRoute>
                  <Video />
                </ProtectedRoute>
              } 
            />
            
            {/* Presentations */}
            <Route 
              path="/presentations" 
              element={
                <ProtectedRoute>
                  <Presentations />
                </ProtectedRoute>
              } 
            />
            
            {/* ========== PUBLIC PAGES ========== */}
            
            <Route path="/privacy_policy" element={<PrivacyPolicy />} />
            <Route path="/refund_policy" element={<RefundPolicy />} />
            <Route path="/cancellation_policy" element={<CancellationPolicy />} />
            <Route path="/home" element={<Home />} />
            <Route path="/Footer" element={<Footer />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />
            <Route path="/payment-failed" element={<PaymentFailed />} />
            <Route path="/AwsCredentialsTester" element={<AWSCredentialsTester />} />
            <Route path="/admin-config" element={<AdminConfig />} />
            
            {/* ========== CATCH ALL ========== */}
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </Layout>
      </div>
    </Router>
  );
}

export default App;